"use strict";

exports.__esModule = true;
exports.CreateDashboardWizard = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _icons = require("@blueprintjs/icons");
var _Form = require("../../Form");
var _Core = require("../../Core");
var _LayoutTemplate = require("../../LayoutTemplate");
var _API = require("../../API");
var _DashboardList = require("../DashboardList");
var _Widgets = require("../../Widgets");
var _Device = require("../../Device");
var _DashboardTagContext = require("../DashboardTagContext");
var _DashboardCollection = require("../DashboardCollection");
var _validateName = require("./validateName");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var emptyDashboard = {
  id: "",
  name: "Blank Canvas",
  element: _Widgets.DashboardWidget.createElement({})
};
var StepWrapper = function StepWrapper(_ref) {
  var dashboardName = _ref.dashboardName,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG,
    style: {
      width: 600,
      minHeight: 470
    }
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: _core.Classes.DIALOG_HEADER
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _core.Classes.DIALOG_HEADER_TITLE
  }, dashboardName ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "CreateDashboardWizard.header.title.withName",
    defaultMessage: "New Dashboard: {dashboardName}",
    values: {
      dashboardName: dashboardName
    }
  }) : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "CreateDashboardWizard.header.title",
    defaultMessage: "New Dashboard"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_BODY
  }, children), /*#__PURE__*/_react["default"].createElement("footer", {
    className: _core.Classes.DIALOG_FOOTER
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_FOOTER_ACTIONS
  }, /*#__PURE__*/_react["default"].createElement(CreateDashboardWizard.BackButton, null), /*#__PURE__*/_react["default"].createElement(CreateDashboardWizard.SubmitButton, {
    lastStepIcon: _icons.IconNames.TICK,
    lastStepText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "CreateDashboardWizard.finishButton.text",
      defaultMessage: "Next"
    })
  })))));
};

/**
 * A wizard for creating new dashboards.
 * @component
 */
var CreateDashboardWizard = exports.CreateDashboardWizard = (0, _Form.createWizard)({
  steps: [{
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(StepWrapper, null, /*#__PURE__*/_react["default"].createElement(_DashboardCollection.DashboardCollectionContext.Consumer, null, function (dashboardCollection) {
        return /*#__PURE__*/_react["default"].createElement(_DashboardTagContext.DashboardTagContext.Consumer, null, function (tagContext) {
          if (tagContext && tagContext.loading) {
            return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
          }
          var deviceTags = tagContext ? tagContext.data : [];
          return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref2) {
            var translate = _ref2.translate;
            return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
              name: "name",
              validate: function validate(value) {
                return (0, _validateName.validateName)(value, dashboardCollection, translate);
              },
              label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
                id: "CreateDashboardWizard.fields.name.label",
                defaultMessage: "Name"
              }),
              helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
                id: "CreateDashboardWizard.fields.name.helperText",
                defaultMessage: "A descriptive name for the new dashboard."
              }),
              requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null)
            }, function (_ref3) {
              var input = _ref3.input;
              return (
                /*#__PURE__*/
                // Avoid DebounceInput: Enter-to-submit races debounce under React 18.
                // eslint-disable-next-line jsx-a11y/no-autofocus
                _react["default"].createElement(_core.InputGroup, _extends({
                  autoFocus: true,
                  maxLength: 35
                }, input))
              );
            }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
              name: "description",
              validate: function validate(value) {
                if (value != null && value.length > 140) {
                  return translate("CreateDashboardWizard.validateDescription.tooLong", "Description is too long, 140 characters max.");
                }
              },
              label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
                id: "CreateDashboardWizard.fields.description.label",
                defaultMessage: "Description"
              }),
              helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
                id: "CreateDashboardWizard.fields.description.helperText",
                defaultMessage: "An optional, short description for the new dashboard"
              })
            }, function (_ref4) {
              var input = _ref4.input;
              return /*#__PURE__*/_react["default"].createElement(_core.TextArea, _extends({
                fill: true,
                rows: 4,
                maxLength: 140
              }, input));
            }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
              name: "tags",
              label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
                id: "DeviceEditorPlantTwin.tags",
                defaultMessage: "Tags"
              }),
              helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
                id: "CreateDashboardWizard.fields.tags.helperText",
                defaultMessage: "Separate multiple tags with comma"
              })
            }, function (_ref5) {
              var input = _ref5.input;
              return /*#__PURE__*/_react["default"].createElement(_Device.DeviceTagSelector, {
                shouldAddItemWhenNotInList: function shouldAddItemWhenNotInList(value) {
                  return !deviceTags.find(function (tag) {
                    return tag === value;
                  });
                },
                multiple: true,
                items: deviceTags,
                onSelect: input.onChange,
                onBlur: input.onBlur,
                selected: input.value || [],
                rightIcon: _icons.IconNames.CARET_DOWN,
                minimal: true
              });
            }));
          });
        });
      }));
    }
  }, {
    render: function render(_ref6) {
      var form = _ref6.form;
      var name = form.getState().values.name;
      var itemPredicate = function itemPredicate(item) {
        return item.element.type === "Dashboard";
      };
      return /*#__PURE__*/_react["default"].createElement(StepWrapper, {
        dashboardName: name
      }, /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref7) {
        var translate = _ref7.translate;
        return /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
          name: "template",
          validate: function validate(input) {
            if (!input) {
              return translate("CreateDashboardWizard.validateTemplate.required", "Template is required.");
            }
          },
          label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "CreateDashboardWizard.fields.template.label",
            defaultMessage: "Choose Template"
          }),
          helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "CreateDashboardWizard.fields.template.helperText",
            defaultMessage: "The template to use as a starting point for your new dashboard."
          })
        }, function (_ref8) {
          var input = _ref8.input;
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              height: 400,
              maxHeight: 400,
              overflowY: "auto"
            }
          }, /*#__PURE__*/_react["default"].createElement(_LayoutTemplate.LayoutTemplateCollection, {
            baseURL: "/api/v3/ui-config/dashboards"
          }, function (collection) {
            return /*#__PURE__*/_react["default"].createElement(_API.CollectionSearcher, {
              collection: collection
            }, function (collectionProps) {
              return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, collectionProps, function (data) {
                return /*#__PURE__*/_react["default"].createElement(_DashboardList.DashboardList, {
                  onItemClick: function onItemClick(template) {
                    input.onChange(template);
                  },
                  selectedIds: input.value ? [input.value.id] : undefined,
                  items: [emptyDashboard].concat(data.filter(itemPredicate))
                });
              });
            });
          }));
        });
      }));
    }
  }]
});